import React from "react";

import SettingsModule from "@app/analytics/account/components/SettingsModule";
import { Divider } from "@app/analytics/account/components/styles";
import type { SettingModule } from "@app/analytics/account/types";
import { useUserSettings } from "@app/analytics/hooks/settings/useUserSettings";
import { useAuthenticated } from "@app/common/auth/useAuth";
import type { UserSettings } from "@app/common/types";

import AssistantDisplaySettings from "./AssistantDisplaySettings";
import JoinPreferenceSettings from "./JoinPreferenceSettings";

const ReadAssistantModule = (props: SettingModule) => {
  const { user } = useAuthenticated();
  const { userSettings, updateUserSettings } = useUserSettings();

  const handleUpdateAccountSettings = (settings: Partial<UserSettings>) => {
    updateUserSettings.mutate(settings);
  };

  return (
    <>
      <SettingsModule {...props}>
        <JoinPreferenceSettings
          user={user}
          onChange={handleUpdateAccountSettings}
        />
        <Divider />
        <AssistantDisplaySettings
          onChange={handleUpdateAccountSettings}
          user={user}
          userSettings={userSettings}
        />
      </SettingsModule>
    </>
  );
};

export default ReadAssistantModule;
